import {Component} from 'react';
import h from 'react-hyperscript';
import {Link} from 'react-router-dom';
import {subhead, caption} from 'Components/Typography/Typography';
import Button from 'Components/Buttons/Buttons';
import Menu from '@material-ui/core/Menu';
import {REPORT} from 'Src/utils/gtm/const';
import {pushEvent as pushGTMEvent} from 'Src/utils/gtm';

class ArchiveListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuAnchorEl: null,
    };
    this.path = `/app/districts/${this.props.districtId}/reports/` +
      `${ this.props.slug }?${ this.props.reportId }`;
    this.activeMenuTab = 0;
    this.handleArchiveClick = this.handleArchiveClick.bind(this);
  }

  handleMenuClick(e, slug) {
    e.preventDefault();
    this.setMenu(e.currentTarget);
  }

  handleClose() {
    this.setMenu(null);
  }

  handleArchiveClick() {
    const props = this.props;
    const {reportId} = props;
    const {
      district_id: districtId,
      district_name: districtName,
      district_domain: districtDomain,
    } = props.userStatus;

    pushGTMEvent(REPORT.TAG, {
      event: REPORT.EVENT,
      action: {report_action: REPORT.ACTION.ARCHIVE_CLICK},
      variables: {
        districtId,
        districtName,
        districtDomain,
        reportId,
      },
    });
  }

  focusMenuItems() {
    const menuButton = document.querySelectorAll('.archive--menu-button')[
        this.activeMenuTab
    ];

    if (menuButton) {
      menuButton.focus();
      this.activeMenuTab = this.activeMenuTab === 1 ? 0 : 1;
    }
  }

  setMenu(slug) {
    this.setState({
      menuAnchorEl: slug,
    });
  }

  render() {
    const classes = `archive__row${this.props.missing_data ? ' disabled' : ''}`;
    return h(
        'tr',
        {
          key: this.props.i,
          className: classes,
          dataitem: this.props.slug,
        },
        [
          h(
              'td',
              {
                datatitle: 'semester',
                className: 'archive__semester',
              },
              h(
                  Link,
                  {
                    key: 'link_key',
                    className: 'archive__item',
                    to: this.path,
                    onClick: this.handleArchiveClick,
                  },
                  h(subhead, null, this.props.title)
              ),
          ),

          h(
              'td',
              {
                datatitle: 'district_name',
                onClick: this.handleArchiveClick,
              },
              h(
                  Link,
                  {
                    key: 'link_key_district_name',
                    to: this.path,
                    onClick: this.handleArchiveClick,
                  },
                  h(
                      'p',
                      {
                        className: 'text--grey archive__item',
                      },
                      this.props.districtName,
                  ),
              ),
          ),

          h(
              'td',
              {
                datatitle: 'last_generated',
                onClick: this.handleArchiveClick,
              },
              h(
                  Link,
                  {
                    key: 'link_key_date',
                    to: this.path,
                    onClick: this.handleArchiveClick,
                  },
                  h(
                      'p',
                      {
                        className: 'text--grey archive__item',
                      },
                      this.props.formattedDate,
                  )
              ),
          ),

          h(
              'td',
              {
                className: 'archive__more',
              },
              [
                h(
                    'span',
                    {
                      className: 'material-icons text--grey',
                      tabIndex: '0',
                      onClick: (e) => {
                        this.handleMenuClick(e, this.props.slug);
                      },
                      onKeyUp: (e) => {
                        if (e.which === 13) {
                          this.handleMenuClick(e, this.props.slug);
                        }
                      },
                    },
                    'more_vert'
                ),
                h(
                    Menu,
                    {
                      key: `archive__menu--${this.props.slug}-key`,
                      id: `archive__menu--${this.props.slug}`,
                      className: 'archive__menu',
                      anchorEl: this.state.menuAnchorEl,
                      open: Boolean(this.state.menuAnchorEl),
                      getContentAnchorEl: null,
                      anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                      },
                      onClose: (e) => {
                        if (e.which === 9) {
                          return this.focusMenuItems();
                        }
                        this.handleClose();
                      },
                    },
                    h('div', null, [
                      h(
                          Button,
                          {
                            to: `${this.path}&print=true`,
                            className: 'archive--menu-button button--left',
                            external: true,
                          },
                          [
                            h(
                                'span',
                                {
                                  className: 'material-icons text--grey',
                                },
                                'vertical_align_bottom'
                            ),
                            h(caption, null, 'Download PDF'),
                          ]
                      ),
                      h(
                          Button,
                          {
                            to: this.path,
                            external: true,
                            className: 'archive--menu-button button--left',
                          },
                          [
                            h(
                                'span',
                                {
                                  className: 'material-icons text--grey',
                                },
                                'open_in_new'
                            ),
                            h(caption, null, 'Open in new tab'),
                          ]
                      ),
                    ])
                ),
              ]
          ),
        ]
    );
  }
}

export default ArchiveListItem;
